import React, { useEffect } from "react";
import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { responsive } from "../../utils/style";
import { onConfirmation } from "../../stores/confirmation";
import { SubmitButton } from "../../components/CustomFields";

const Confirmation = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const dispatch = useDispatch();
  const { isSuccess, errorMessage } = useSelector(
    (state) => state.confirmation
  );

  useEffect(() => {
    dispatch(onConfirmation({ token }));
  }, []);

  return (
    <Container>
      <Background>
        {isSuccess ? (
          <>
            <Topic>ลงทะเบียนสำเร็จ</Topic>
            <Remark>เข้าสู่ระบบเพื่อเริ่มใช้งาน</Remark>
            <ButtonStyled onClick={() => navigate("/login")}>
              เข้าสู่ระบบ
            </ButtonStyled>
          </>
        ) : (
          <>
            <Topic>ลงทะเบียนไม่สำเร็จ</Topic>
            <Remark>{errorMessage}</Remark>
          </>
        )}
      </Background>
    </Container>
  );
};

export default Confirmation;

const Container = styled.div`
  font-family: Noto Sans Thai, Noto Sans;
  background-color: #fffbeb;
`;
const Background = styled.div`
  width: 1144px;
  background-color: white;
  margin: auto;
  height: 100vh;
  padding-top: 40px;

  ${responsive.tablet(css`
    width: 100%;
  `)}
`;
const Topic = styled.h5`
  font-style: normal;
  font-weight: 600;
  font-size: 23px;
  line-height: 28px;
  text-align: center;
  letter-spacing: -0.02em;
  color: #058459;
`;
const Remark = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 26px;
  text-align: center;
  color: #4b5768;
  margin-top: 24px;
`;
const ButtonStyled = styled(SubmitButton)`
  display: block;
  margin: auto;
  margin-top: 80px;
`;
